import { Injectable } from '@angular/core';
import { StatApiService } from './api/stat-api.service';

@Injectable({
  providedIn: 'root',
})
export class StatService {
  constructor(private statApi: StatApiService) {}

  getPoliciesByDay() {
    return this.statApi.getPoliciesByDay();
  }

  getAgenciesByDay() {
    return this.statApi.getAgenciesByDay();
  }

  getMoneyPerMonth() {
    return this.statApi.getMoneyPerMonth();
  }

  getPackages() {
    return this.statApi.getPackages();
  }

  getAgencyStates() {
    return this.statApi.getAgencyStates();
  }

  getPolicyStates() {
    return this.statApi.getPolicyStates();
  }

  getPolicyByInsuranceTypes() {
    return this.statApi.getPolicyByInsuranceTypes();
  }
}
